import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Typography,
  Container,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Grid,
  FormControlLabel,
  Checkbox,
  Modal,
  Box,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from "@mui/material";
import ErrorPage from "./error-page";

const ChatHeader = () => {
  useEffect(() => {
    document.title = "Booking";
  }, []);

  return (
    <Typography variant="h4" align="center" gutterBottom>
      Book Now
    </Typography>
  );
};
const TeacherModal = ({ isModalOpen, handleModalClose, bookingsData, handleBookingAction }) => (
  <Modal open={isModalOpen} onClose={handleModalClose}>
    <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 600, bgcolor: 'background.paper', boxShadow: 24, p: 4 }}>
      <Paper>
        <Typography variant="h6" sx={{ marginBottom: 2 }}>
          Bookings
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Booking Id</TableCell>
                <TableCell>Student Id</TableCell>
                <TableCell>Start Time</TableCell>
                <TableCell>End Time</TableCell>
                <TableCell>Booking Status</TableCell>


              </TableRow>
            </TableHead>
            <TableBody>
              {bookingsData.map((booking) => (
                <TableRow key={booking.id}>
                  <TableCell>{booking.id}</TableCell>
                  <TableCell>{booking.student_id}</TableCell>
                  <TableCell>{booking.start_time}</TableCell>
                  <TableCell>{booking.end_time}</TableCell>

                  <TableCell>
                    {booking.booking_status === 0 ? (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleBookingAction(booking.id)}
                      >
                        Book
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        color="primary"
                        disabled
                      >
                        Booked
                      </Button>
                    )}
                  </TableCell>

                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  </Modal>
);

function App() {
  const [selectedDate, setSelectedDate] = useState("");
  const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
  const [userExists, setUserExists] = useState(false);
  const [userCredentials, setUserCredentials] = useState(null);
  const { id, user_name, key, user_type } = useParams();
  const currentDate = new Date().toISOString().split("T")[0];
  const [selectedTimeSlots, setSelectedTimeSlots] = useState([]);
  const [isBookingConfirmed, setBookingConfirmed] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [bookingsData, setBookingsData] = useState([]);

  const handleBookingAction = async (bookingId) => {
    try {
      console.log('Booking ID:', bookingId);

      const response = await fetch("/api/update_booking_status", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          slot_id: bookingId,
        }),
      });

      console.log('Response:', response);

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Error Data:', errorData);

        if (errorData.detail && Array.isArray(errorData.detail) && errorData.detail.length > 0) {
          console.error('Error Details:', errorData.detail[0]);
        }

        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      // Assuming you want to update the UI after successful booking
      // You can fetch the updated bookings data here if needed
      await fetchBookingsData();
    } catch (error) {
      console.error("Error updating booking status:", error.message);
    }
  };
  const handleModalOpen = async () => {
    // Fetch bookings data when the modal is about to open
    await fetchBookingsData();
    setModalOpen(true);
  };

  const handleModalClose = () => {
    // Clear booking data when the modal is closed
    setBookingsData([]);
    setModalOpen(false);
  };
  const fetchBookingsData = async () => {
    try {
      // Add start_time and end_time to your payload if they are required
      const payload = {
        teacher_id: parseInt(id),
        start_time: startTime,
        end_time: endTime
      };

      console.log('Request Payload:', payload);

      const response = await fetch("/api/get_bookings_data", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      console.log('Response Status:', response.status);

      if (!response.ok) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const result = await response.json();
      console.log('Bookings Data:', result);

      setBookingsData(result);
    } catch (error) {
      console.error("Error fetching bookings data:", error.message);
    }
  };
  const fetchTeacherAvailability = async () => {
    const apiUrl = "/api/get_teacher_availability"; // Update with your server URL

    try {
      const responseData = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          teacher_id: parseInt(id), // Ensure id is a valid integer
          selected_date: selectedDate,
        }),
      });

      if (!responseData.ok) {
        throw new Error(
          `Error: ${responseData.status} - ${responseData.statusText}`
        );
      }

      const result = await responseData.json();

      // Log availability to the console
      console.log("Availability received from backend:", result.availability);

      setAvailableTimeSlots(result.availability);
    } catch (error) {
      console.error("Error fetching teacher availability:", error.message);
    }
  };
  const handleTimeSlotSelection = (selectedTime) => {
    // Check if the selected time slot is already in the list
    const isAlreadySelected = selectedTimeSlots.some(
      (timeSlot) =>
        timeSlot.start_time === selectedTime.start_time &&
        timeSlot.end_time === selectedTime.end_time
    );

    if (isAlreadySelected) {
      // If already selected, remove it from the list
      setSelectedTimeSlots((prevSelectedTimeSlots) =>
        prevSelectedTimeSlots.filter(
          (timeSlot) =>
            timeSlot.start_time !== selectedTime.start_time ||
            timeSlot.end_time !== selectedTime.end_time
        )
      );
    } else {
      // If not selected, add it to the list
      setSelectedTimeSlots((prevSelectedTimeSlots) => [
        ...prevSelectedTimeSlots,
        selectedTime,
      ]);
    }
  };

  useEffect(() => {
    const fetchUserCredentials = async (id, user_name, key, user_type) => {
      const apiUrl = "/api/get_user_credentials";

      try {
        const responseData = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: id,
            user_name: user_name,
            key: key,
            user_type: user_type,
          }),
        });

        if (!responseData.ok) {
          throw new Error(
            `Error: ${responseData.status} - ${responseData.statusText}`
          );
        }

        const result = await responseData.json();
        setUserCredentials(result);

        const checkUserUrl = "/api/check_user";
        const response = await fetch(checkUserUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: result.id,
            user_name: result.user_name,
            key: result.key,
            user_type: result.user_type,
          }),
        });

        if (response.ok) {
          const userExistsResult = await response.json();
          setUserExists(userExistsResult.exists);
        } else {
          console.error(
            `Error: ${response.status} - ${response.statusText}`
          );
        }
      } catch (error) {
        console.error("Error fetching user credentials:", error.message);
      }
    };

    fetchUserCredentials(id, user_name, key, user_type);
  }, [id, user_name, key, user_type]);

  useEffect(() => {
    if (selectedDate && userCredentials) {
      fetchTeacherAvailability(userCredentials.user_id, selectedDate);
    }
  }, [selectedDate, userCredentials]);

  if (!userExists) {
    return <div><ErrorPage /></div>;
  }

  const generateTimeSlots = (start, end, intervalMinutes = 30) => {
    const timeSlots = [];
    let currentTime = new Date(start);

    while (currentTime <= end) {
      timeSlots.push({
        start_time: currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
        end_time: new Date(currentTime.getTime() + intervalMinutes * 60000)
          .toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      });
      currentTime = new Date(currentTime.getTime() + intervalMinutes * 60000);
    }

    return timeSlots;
  };

  // Generate time slots from 6:00 to 23:00 with a 30-minute interval
  const startTime = new Date(currentDate);
  startTime.setHours(6, 0, 0, 0);
  const endTime = new Date(currentDate);
  endTime.setHours(23, 0, 0, 0);
  const generatedTimeSlots = generateTimeSlots(startTime, endTime);
  const isTimeSlotAvailable = (startTime, endTime) => {
    const selectedStartTime = new Date(`${selectedDate} ${startTime}`);
    const selectedEndTime = new Date(`${selectedDate} ${endTime}`);

    // Check if the selected time slot overlaps with any available time slots
    return availableTimeSlots.some((availability) => {
      const availabilityStartTime = new Date(availability.start_time);
      const availabilityEndTime = new Date(availability.end_time);

      return (
        selectedStartTime >= availabilityStartTime &&
        selectedEndTime <= availabilityEndTime
      );
    });
  };

  const deleteSchedule = async () => {
    try {
      if (selectedTimeSlots.length === 0) {
        console.error("No time slots selected.");
        return;
      }

      // Assuming selectedTimeSlots[0] is the first selected time slot
      const selectedTimeSlot = selectedTimeSlots[0];

      // Parse the time strings with the correct format
      const parsedStartTime = new Date(
        `${selectedDate} ${selectedTimeSlot.start_time}`
      );
      const parsedEndTime = new Date(`${selectedDate} ${selectedTimeSlot.end_time}`);

      // Set the time zone to UTC
      parsedStartTime.setUTCHours(parsedStartTime.getHours());
      parsedEndTime.setUTCHours(parsedEndTime.getHours());

      // Use the parsed times directly without converting to ISO
      const isoStartTime = parsedStartTime.toISOString();
      const isoEndTime = parsedEndTime.toISOString();

      const response = await fetch("/api/delete_schedule", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          teacher_id: parseInt(id), // Use the id parameter as teacher_id
          start_time: isoStartTime,
          end_time: isoEndTime,
        }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      // Reset the form after successful deletion
      setSelectedDate("");
      setSelectedTimeSlots([]);
      setBookingConfirmed(false);

      const result = await response.json();
      console.log(result); // Log the result for debugging
    } catch (error) {
      console.error("Error deleting schedule:", error.message);
    }
  };
  return (
    <div className="App">
      <Container maxWidth="sm" sx={{ pt: 2 }}>
        <ChatHeader />
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 2 }}>
          <Button variant="contained" color="primary" onClick={handleModalOpen}>
            View Bookings
          </Button>
        </Box>
        <FormControl fullWidth sx={{ marginBottom: 6, justifyContent: 'center' }}>
          <InputLabel id="course-select-label">
            <Typography variant="body1" component="span" style={{ color: 'black' }}>
              Hello Teacher:
            </Typography>
            <Typography variant="body1" component="span" style={{ color: 'black', fontSize: '18px', fontWeight: 'bold' }}>
              {`${user_name}`}
            </Typography>
          </InputLabel>
        </FormControl>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              type="date"
              label="Select Date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              inputProps={{ min: currentDate }}
            />
          </Grid>
          {selectedDate &&
            generatedTimeSlots.map((timeSlot) => (
              <Grid key={timeSlot.start_time} item xs={3}>
                <Button
                  variant="contained"
                  disabled={
                    timeSlot.start_time < userCredentials.start_time ||
                    timeSlot.end_time > userCredentials.end_time ||
                    !isTimeSlotAvailable(timeSlot.start_time, timeSlot.end_time)
                  }
                  onClick={() => handleTimeSlotSelection(timeSlot)}
                  style={{
                    backgroundColor: selectedTimeSlots.some(
                      (selected) =>
                        selected.start_time === timeSlot.start_time &&
                        selected.end_time === timeSlot.end_time
                    )
                      ? "red" // Change the background color for selected time slots
                      : "blue", // Use your desired color for non-selected time slots
                    // Add a condition to set the background color for disabled buttons
                    ...(timeSlot.start_time < userCredentials.start_time ||
                      timeSlot.end_time > userCredentials.end_time ||
                      !isTimeSlotAvailable(timeSlot.start_time, timeSlot.end_time)
                      ? { backgroundColor: "gray" }
                      : {}),
                  }}
                >
                  <Typography variant="body2" style={{ color: 'white' }}>
                    {`${timeSlot.start_time}`}
                  </Typography>
                  <Typography variant="body2" style={{ color: 'white', display: 'none' }}>
                    {`${timeSlot.end_time}`}
                  </Typography>
                </Button>
              </Grid>
            ))}
        </Grid>
        {selectedTimeSlots.length > 0 && endTime && (
          <React.Fragment>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isBookingConfirmed}
                    onChange={(e) => setBookingConfirmed(e.target.checked)}
                    color="primary"
                  />
                }
                label="I confirm the Delete Schedule"
              />
            </Grid>
          </React.Fragment>
        )}

        {isBookingConfirmed && (
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={deleteSchedule}
            >
              Delete Schedule
            </Button>
          </Grid>
        )}
        <TeacherModal
          isModalOpen={isModalOpen}
          handleModalClose={handleModalClose}
          bookingsData={bookingsData}
          handleBookingAction={handleBookingAction}
        />
      </Container>
    </div>
  );
}

export default App;